import { auth, db } from "../../authentication/firebase";
import { deleteField, doc, deleteDoc, updateDoc } from "firebase/firestore";
import firebaseApi from "../../utils/firebaseApi";


export const toggleSelection = ({
  data,
  selectionType,
  headingId,
  recipeId,
  ingredientIndex,
  isChecked,
}) => {
  const newData = JSON.parse(JSON.stringify(data));

  if (newData) {
    if (selectionType === "heading") {
      if (newData[headingId]) {
        newData[headingId].checked = isChecked;
        newData[headingId].deleteable = isChecked;
        console.log("keys", Object.keys(newData[headingId].items));
        Object.keys(newData[headingId].items).forEach((recipeId) => {
          newData[headingId].items[recipeId].checked = isChecked;

          newData[headingId].items[recipeId].ingredients.data.forEach(
            (ingredient) => {
              ingredient.checked = isChecked;
            }
          );
        });
      }
    } else if (selectionType === "recipe") {
      if (newData[headingId]?.items[recipeId]) {
        newData[headingId].items[recipeId].checked = isChecked;
        newData[headingId].deleteable = isChecked;

        newData[headingId].items[recipeId].ingredients.data.forEach(
          (ingredient) => {
            ingredient.checked = isChecked;
          }
        );
        if (
          Object.values(newData[headingId].items).every(
            (recipe) => recipe.checked
          )
        ) {
          newData[headingId].checked = true;
        } else if (
          Object.values(newData[headingId].items).find(
            (recipe) => !recipe.checked
          )
        ) {
          newData[headingId].checked = false;
        }
      }
    } else if (selectionType === "ingredients") {
      console.log(
        "index",
        newData[headingId]?.items[recipeId]?.ingredients.data[ingredientIndex]
      );
      if (
        newData[headingId]?.items[recipeId]?.ingredients.data[ingredientIndex]
      ) {
        newData[headingId].items[recipeId].ingredients.data[
          ingredientIndex
        ].checked = isChecked;
      }
    }
  }
  return newData;
};

export function sortIngredientsAlphabeticallly(ingredients) {
  return [...ingredients].sort((a, b) => {
    const nameA = a.nameClean.toLowerCase();
    const nameB = b.nameClean.toLowerCase();

    if (nameA < nameB) return -1;
    if (nameA > nameB) return 1;
    return 0;
  });
}

export async function deleteCartRecipes(cartData) {
  const newData = JSON.parse(JSON.stringify(cartData));
  for (const [date, dateData] of Object.entries(cartData)) {
    const [yy, mm, dd] = date.split("-");
    const dateRef = doc(db, `shoppingCart/${auth.currentUser?.uid}/${yy}-${mm}`, dd);

    if (dateData.checked) {
      // Delete entire date document
      await deleteDoc(dateRef);
      delete newData[date];
    } else {
      // Delete individual recipes
      for (const [recipeId, recipe] of Object.entries(dateData.items)) {
        if (recipe.checked) {
          await updateDoc(dateRef, {
            [recipe.data.plannedFor]: deleteField(),
          });
          delete newData[date].items[recipeId];
        }
      }
    }
  }

  return newData;
}

export function getNoOfRecipes(cartRecipes) {
  let noOfRecipes = 0;
  Object.values(cartRecipes).forEach((dateData) => {
    Object.values(dateData.items).forEach((recipe) => {
      noOfRecipes += 1;
    });
  });
  return noOfRecipes;
}

export async function fetchCart(urlPath) {
  try {
    if (auth.currentUser?.uid) {
      const collectionName =
        urlPath === "/cart" ? "shoppingCart" : "cartHistory";
      const url = `/getSubCollectionsData?docPath=${collectionName}/${auth.currentUser?.uid}`;
      const response = await firebaseApi.get(url, auth.currentUser?.uid);
      const fetchedRecipes = response.data;
      let cartRecipes = {};
      Object.entries(fetchedRecipes).forEach(([month, value]) => {
        Object.entries(value).forEach(([date, data]) => {
          cartRecipes[`${month}-${date}`] = {};
          Object.entries(data).forEach(([mealType, recipe]) => {
            cartRecipes[`${month}-${date}`][
              `${recipe.id}${recipe.title.toLowerCase().replace(/ /g, "-")}`
            ] = {
              data: recipe,
              checked: false,
              ingredients: {
                data: recipe.extendedIngredients
                  ? recipe.extendedIngredients.map((ingredient) => ({
                      ...ingredient,
                      checked: false,
                    }))
                  : [],
                checked: false,
              },
            };
          });
        });
      });

      if (Object.keys(cartRecipes)?.length > 0) {
        let formatedRecipes = {};
        const sortedEntries = sortDatesDescending(Object.entries(cartRecipes));

        sortedEntries.forEach(([date, recipes]) => {
          formatedRecipes[date] = { checked: false, items: recipes };
        });
        console.log("cart recipes", formatedRecipes);

        return {
          cartRecipes: formatedRecipes,
          noOfRecipes: getNoOfRecipes(formatedRecipes),
          cartRoute: urlPath,
        };
      }
    }
  } catch (e) {
    console.log("error while fetching cart", e);
  }
}

function sortDatesDescending(entries) {
  return entries.sort(([dateA], [dateB]) => {
    const timestampA = new Date(dateA).getTime();
    const timestampB = new Date(dateB).getTime();
    return timestampB - timestampA;
  });
}
